import { jsx } from "react/jsx-runtime";
import { DateTimePicker as DateTimePicker$1 } from "@mui/x-date-pickers/DateTimePicker";
import { getIn } from "formik";
import { createErrorHandler } from "./errorHandler.js";
function fieldToDateTimePicker({
  field: { onChange: _onChange, ...field },
  form: {
    isSubmitting,
    touched,
    errors,
    setFieldValue,
    setFieldError,
    setFieldTouched
  },
  textField: { helperText, onBlur, ...textField } = {},
  disabled,
  label,
  onChange,
  onError,
  ...props
}) {
  const fieldError = getIn(errors, field.name);
  const showError = getIn(touched, field.name) && !!fieldError;
  const onBlurDefault = () => {
    setFieldTouched(field.name, true, true);
  };
  const onChangeDefault = (date) => {
    setFieldTouched(field.name, true, false);
    setFieldValue(field.name, date, true);
  };
  return {
    disabled: disabled ?? isSubmitting,
    onChange: onChange ?? onChangeDefault,
    onError: onError ?? createErrorHandler(fieldError, field.name, setFieldError),
    slotProps: {
      textField: {
        error: showError,
        helperText: showError ? fieldError : helperText,
        label,
        onBlur: onBlur ?? onBlurDefault,
        ...textField
      }
    },
    ...field,
    ...props
  };
}
function DateTimePicker(props) {
  return /* @__PURE__ */ jsx(DateTimePicker$1, { ...fieldToDateTimePicker(props) });
}
DateTimePicker.displayName = "FormikMUIDateTimePicker";
export {
  DateTimePicker,
  fieldToDateTimePicker
};
//# sourceMappingURL=DateTimePicker.js.map
